module.exports = __webpack_public_path__ + "img/info.606bcb3c.png";